module.exports = __webpack_public_path__ + "img/gif12.8c5a8d0f.gif";